import { Component, OnInit, ViewChild, Inject, Optional } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CamposCustomizablesCatalogosService } from './services/campos-customizables-catalogos.service';
import { ICampoCustomizableCatalogo, ICampoCustomizableCatalogoRequest, ICampoCustomizableCatalogoResponse } from './interfaces/campo-customizable-catalogo.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-campos-customizables-catalogos',
  templateUrl: './campos-customizables-catalogos.component.html',
  providers: [MessageService]
})
export class CamposCustomizablesCatalogosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedCampo: ICampoCustomizableCatalogo | null = null;
  dataSource: ICampoCustomizableCatalogo[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  modoActividad: boolean = false;

  displayedColumns = [
    { field: 'sCampo', header: 'Campo', sortable: true },
    { field: 'sTabla', header: 'Tabla', sortable: true },
    { field: 'sTipo', header: 'Tipo', sortable: true },
    { field: 'iLongitud', header: 'Longitud', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<CamposCustomizablesCatalogosComponent>,
    private messageService: MessageService,
    private camposCustomizablesCatalogosService: CamposCustomizablesCatalogosService
  ) {}

  ngOnInit(): void {
    // Verificar si estamos en modo actividades
    this.modoActividad = this.data?.modoActividad || false;
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request: ICampoCustomizableCatalogoRequest = {
      tope: '',
      cmd: '',
      sCampo: '',
      sTabla: '',
      sTipo: '',
      iLongitud: 0
    };

    this.camposCustomizablesCatalogosService.getCamposCustomizablesCatalogos(request).subscribe({
      next: (response: ICampoCustomizableCatalogoResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los campos customizables catálogos'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los campos customizables catálogos'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedCampo = null;
    this.displayDialog = true;
  }

  openUpdate(row: ICampoCustomizableCatalogo): void {
    this.selectedCampo = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: ICampoCustomizableCatalogo): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este campo customizable catálogo?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.camposCustomizablesCatalogosService.deleteCampoCustomizableCatalogo(row).subscribe({
          next: (response) => {
            const errorCode = response.data?.[0]?.error;
            if (errorCode === "0") {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Campo customizable catálogo eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: errorCode || 'Error al eliminar el campo customizable catálogo'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el campo customizable catálogo'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedCampo = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }

  // Método para cerrar el modal cuando se usa con Angular Material Dialog
  closeDialog(): void {
    if (this.data?.onClose) {
      this.data.onClose();
    }
    if (this.dialogRef) {
      this.dialogRef.close(true);
    }
  }
} 